<app-modal [modalId]="modalId">
  <app-offer-modals-header
    heading={{bidHistoryModalTranslations?.heading}}
    [tenantName]="tenantName"
    [headingId]="modalId + '-title'"
  ></app-offer-modals-header>

  <div class="modal__content" *transloco="let convert;">
    <app-offer-history [vin]="modalItem.itemDetail.vin" [bidHistory]="bidHistory"></app-offer-history>

    <div class="d-flex flex-column flex-lg-row lg-justify-content-start">
      <button
        class="btn btn-primary"
        type="submit"
        (click)="cancel()"
        data-track-elem="button"
        data-track-name="Close"
        data-track-trigger="close"
      >
      {{convert('common.btnClose')}}
      </button>
    </div>
  </div>
  <app-modal-close (close)="cancel()"></app-modal-close>
</app-modal>
